import makeRequest from "rdx/utils/makeRequest";
import { all, put } from "redux-saga/effects";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* deleteSalesTeam(action) {
  const { teamId } = action.payload;
  const { success, data, error } = yield* makeRequest.delete(`/sales_teams/${teamId}`);

  if (success && data) {
    yield all([
      put(actions.getTeams()),
      put(actions.getSellers()),
      put(actions.getAvailableManagers()),
      put(actions.getAvailableSupport()),
      put(actions.setAlertMessageVisible({ message: messages.SUCCESS_DELETING_SALES_TEAM, severity: "success" })),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_DELETING_SALES_TEAM,
    });
  }

  return null;
}

export default deleteSalesTeam;
